// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { IRoute } from '../';
import WarrantyUpdate from './WarrantyUpdate';

const warrantyUpdateRoutes: IRoute[] = [
    {
        crumbText: 'warranty_update',
        component: WarrantyUpdate,
        path: '/device/warranty',
    },
];

export default warrantyUpdateRoutes;
